import { type FC } from 'react'

import { NumberFormatter } from '@/components/elements'

type Props = {
  /** 荷姿数 */
  value: number | null
}

/**
 * 荷姿数を表示用にフォーマットする
 * - 小数点第1位まで表示して、第2位以降は切り上げ
 */
export const PackageCountFormatter: FC<Props> = ({ value }) => {
  const formatValue = value !== null ? Math.ceil(value * 10) / 10 : null
  return <NumberFormatter value={formatValue} />
}
/**
 * 荷姿数を小数点第1位までで切り上げて返すユーティリティ
 * @param value 荷姿数（numberまたはnull/undefined）
 * @returns 小数点第1位で切り上げた値 or null
 */
export function PackageCountFormatValue(
  value: number | null | undefined
): number | null {
  if (value === null || value === undefined) {
    return null
  }
  return Math.ceil(value * 10) / 10
}
